import { slugify, strToBool } from '../helpers/helpers';

function Radio(props) {
  const {
    options, value, name, onChange,
  } = props;

  return (
    <div className="flex flex-row">
      {options.map((o) => (

        <div key={slugify(o.label)} className="bg-white bg-opacity-10 text-white font-bold ml-4 mr-4 px-8 p-4">
          <input onChange={onChange} className="text-sentric-dark-gray" id={slugify(o.label)} type="radio" name={name} value={o.value} defaultChecked={value !== null && o.value === strToBool(value)} />
          <label className="p-2" htmlFor={slugify(o.label)}>
            {o.label}
          </label>
        </div>
      ))}

    </div>
  );
}

export default Radio;
